import { render, staticRenderFns } from "./CxMarginOverview.vue?vue&type=template&id=7cc2a401&scoped=true&"
import script from "./CxMarginOverview.vue?vue&type=script&lang=js&"
export * from "./CxMarginOverview.vue?vue&type=script&lang=js&"
import style0 from "./CxMarginOverview.vue?vue&type=style&index=0&id=7cc2a401&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cc2a401",
  null
  
)

export default component.exports